import React from 'react';

/**
 * 手当申請状況（C3_RESDUC-1877）
 *
 * 手当マスタの登録件数は企業ごとに違うため、サーバから返ってきた項目の分だけ **行** を作る。
 * 手当が増えても横に伸びないよう縦型にしている。
 * 表示対象は画面と同じ母集団（申請中を含む・承認済みの削除申請は除く）。確定 CSV とは条件が違う。
 */
const AllowanceSubTotalTable: React.FC<{
  allowanceSubtotalItem: any,
  allowanceSubtotals: any,
}> = ({
  allowanceSubtotalItem,
  allowanceSubtotals,
}) => (
  <div className="table-responsive">
    <table
      id="allowanceSubTotalList"
      className="table table-bordered table-condensed"
      cellSpacing="0"
      style={{ whiteSpace: 'nowrap', width: 'auto', minWidth: '320px' }}
    >
      <thead>
        <tr role="row">
          <th style={{ width: '200px', textAlign: 'center' }}>手当名</th>
          <th style={{ width: '160px', textAlign: 'center' }}>申請値合計</th>
        </tr>
      </thead>
      <tbody>
        {
          allowanceSubtotalItem && allowanceSubtotalItem.map((item: any, index: number) => {
            // ★ 合計値は allowanceSubtotalItem 側ではなくスタッフ行（attendAllowanceSubtotals）に入る。
            //    allowanceSubtotalItem は列の定義（手当名・単位）で allowanceTotal は null。
            //    並び順はサーバ側で揃えてあるので添字で引く。
            const cell = allowanceSubtotals && allowanceSubtotals[index];
            return (
              <tr role="row" key={item.allowanceId}>
                <td>{item.allowanceName}</td>
                <td style={{ textAlign: 'right' }}>
                  {`${Number((cell && cell.allowanceTotal) || 0).toLocaleString()}${item.dispUnit || ''}`}
                </td>
              </tr>
            );
          })
        }
      </tbody>
    </table>
  </div>
);
export default AllowanceSubTotalTable;
